import * as Yup from "yup";
import { EppsLoanInformation } from "../../../../models/epps-models";
const getCustomFieldValidations = (formValues) => {
  const feeAmount = formValues("loanInformation.feeAmount");
  const financed = formValues("loanInformation.feeAmountFinanced");
  const paidInCash = formValues("loanInformation.feeAmountPaidinCash");
  const standardProducts = formValues("standardProducts") ?? [];
  const specialProducts = formValues("specialProducts") ?? [];
  const productType = formValues("productType");
  const term = formValues("loanInformation.term");
  const totalMortgageAmount = formValues("loanInformation.totalMortgageAmount");
  const cashOut = formValues("loanInformation.cashOut");
  const loanPurpose = formValues("loanInformation.loanPurpose");
  const productIsHeloc = [66, 21, 64, 117, 77, 90, 65, 67];
  return [
    {
      path: "standardProducts",
      label: "Standard Products",
      validation: Yup.mixed().nullable().test(
        "multiple-fha-va-usda-check",
        "Only one of FHA, VA or USDA can be selected.",
        () => {
          if ([
            EppsLoanInformation.StandardProducts.FHA,
            EppsLoanInformation.StandardProducts.VA,
            EppsLoanInformation.StandardProducts.USDA
          ].filter((num) => standardProducts?.includes(num)).length >= 2) {
            return false;
          }
          return true;
        }
      ).test(
        "at-least-one-product-check",
        "At least one Standard or Special product is required.",
        () => {
          return standardProducts.length > 0 || specialProducts.length > 0;
        }
      )
    },
    {
      path: "specialProducts",
      label: "Special Products",
      validation: Yup.mixed().nullable().test(
        "at-least-one-product-check",
        "At least one Standard or Special product is required.",
        () => {
          return standardProducts.length > 0 || specialProducts.length > 0;
        }
      )
    },
    {
      path: "loanInformation.feeAmountFinanced",
      label: "Fee Amount Financed",
      validation: Yup.number().max(feeAmount, `Must be less than or equal to $${feeAmount}`).test(
        "combined-financed-cash-check",
        `Financed Amount + Paid in Cash must equal $${feeAmount}`,
        () => {
          if (typeof feeAmount !== "number" || typeof financed !== "number" || typeof paidInCash !== "number") {
            return true;
          }
          return financed + paidInCash === feeAmount;
        }
      )
    },
    {
      path: "loanInformation.feeAmountPaidinCash",
      label: "Fee Amount Paid In Cash",
      validation: Yup.number().max(feeAmount, `Must be less than or equal to $${feeAmount}`).test(
        "combined-financed-cash-check",
        `Financed Amount + Paid in Cash must equal $${feeAmount}`,
        () => {
          if (typeof feeAmount !== "number" || typeof financed !== "number" || typeof paidInCash !== "number") {
            return true;
          }
          return financed + paidInCash === feeAmount;
        }
      )
    },
    {
      path: "productType",
      label: "Product Type",
      validation: Yup.mixed().nullable().test(
        "product-or-term-required",
        "Either enter a Custom Term or choose a Loan Term",
        () => {
          const hasLoanterm = Array.isArray(productType) && productType.length > 0;
          const hasCustomTerm = term != null && term !== "";
          const hasBoth = hasLoanterm && hasCustomTerm;
          const hasNeither = !hasLoanterm && !hasCustomTerm;
          if (hasNeither || hasBoth) return false;
          return true;
        }
      )
    },
    {
      path: "loanInformation.term",
      label: "Custom Term",
      validation: Yup.number().nullable().min(1, "Custom Term must be an integer value from 1 to 360").max(360, "Custom Term must be an integer value from 1 to 360")
    },
    {
      path: "loanInformation.cashOut",
      label: "Cash Out",
      validation: Yup.mixed().nullable().test(
        "cash-out-exceeds-total-check",
        "Cash out amount exceeds total loan amount",
        () => {
          if (loanPurpose === 3) {
            const hasHelocLoanTerm = Array.isArray(productType) && productType.length > 0 && productIsHeloc.some((prod) => productType?.includes(prod));
            if (typeof cashOut !== "number" || typeof totalMortgageAmount !== "number" || hasHelocLoanTerm) {
              return true;
            }
            return cashOut <= totalMortgageAmount;
          }
          return true;
        }
      )
    }
  ];
};
export {
  getCustomFieldValidations
};
